import SquareEmptyIcon from "../images/SquareEmptyIcon.mjs";

/**
 * App de-selected checkbox
 * @see {GlyphIcon}
 * @see {SquareEmptyIcon}
 */
const AppCheckboxOffIcon = class extends SquareEmptyIcon {};

export default AppCheckboxOffIcon;